import { CreateUserForm } from "./components/create-user-form";
import { EditUserForm } from "./components/edit-user-form";

interface UserFormProps {
  userId?: number;
  onCancel: () => void;
  onSuccess: () => void;
}

export function UserForm({ userId, onCancel, onSuccess }: UserFormProps) {
  if (userId) {
    return (
      <EditUserForm
        userId={userId}
        onCancel={onCancel}
        onSuccess={onSuccess}
      />
    );
  }

  return (
    <CreateUserForm
      onCancel={onCancel}
      onSuccess={onSuccess}
    />
  );
}
